<template>
  <div>
    <b-row>
      <b-col>
        <h3>Tableau Permissions</h3>
      </b-col>
    </b-row>
    <b-row class="my-3 ml-3">
      <b-col cols="12" xl="6" lg="8" md="10">
        <b-row class="border-bottom border-top">
          <b-col cols="3"><small class="">Group</small></b-col>
          <b-col><small class="">UserName</small></b-col>
        </b-row>
        <b-row class="border-bottom" v-for="id in sortedTableauIdentities" :key="id.tableauAuthConfigId">
          <b-col cols="3"><small class="text-muted">{{ id.tableauAuthConfigId }}</small></b-col>
          <b-col><small class="text-muted">{{ id.userName }}</small></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="mb-3" v-for="tableauIdentity in groupOfTableauIdentities" :key="tableauIdentity.id">
          <div v-if="tableauIdentity.users && tableauIdentity.users.length">
            
            <div class="px-3 pt-2">
              <b-row class="border-bottom pb-2">
                <b-col>
                  <span class="font-weight-bold">{{ tableauIdentity.id || 'Not assigned' }}</span><span class="ml-3"> {{ tableauIdentity.name }}</span>
                </b-col>
              </b-row>
              <b-row class="py-1 border-bottom" v-for="user in tableauIdentity.users" :key="user.id">
                <b-col>{{user.email}}</b-col>
                <b-col>
                  <b-form-select size="sm" v-model="user.tableauIdentity" :options="formattedTableauIdentities"
                                 @input="editPermission(user)"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

      </b-col>
    </b-row>
    <!--    <b-row>-->
    <!--      <b-col>-->
    <!--        <b-row class="mb-2" v-for="user in tableauUsers" :key="user.id">-->
    <!--          <b-col>-->
    <!--            {{ user.email }}-->
    <!--          </b-col>-->
    <!--          <b-col>-->
    <!--            <b-form-select size="sm" v-model="user.tableauIdentity" :options="formattedTableauIdentities"-->
    <!--                           @change="editPermission(user)"/>-->
    <!--          </b-col>-->
    <!--        </b-row>-->
    <!--      </b-col>-->
    <!--    </b-row>-->
  </div>
</template>

<script>
import http from '@/mixins/http';
import notification from '@/mixins/notification';
import _ from 'lodash';

export default {
  name: "TableauPermissions",
  mixins: [http, notification],
  data() {
    return {
      tableauUsers: [],
      tableauIdentities: []
    }
  },
  computed: {
    sortedTableauIdentities() {
      return _.orderBy(this.tableauIdentities, ['tableauAuthConfigId']);
    },
    formattedTableauIdentities() {
      return [...[{text: 'Not assigned', value: null}], ..._.map(this.sortedTableauIdentities, (id) => {
        return {text: id.tableauAuthConfigId, value: id.tableauAuthConfigId};
      })];
    },
    groupOfTableauIdentities() {
      const identities = [...[{id: null, name: null}], ..._.map(this.sortedTableauIdentities, (id) => {
        return {
          id: id.tableauAuthConfigId,
          name: id.userName,
        };
      })];
      return _.map(identities, (id) => {
        return {
          id: id.id,
          name: id.name,
          users: _.chain(this.tableauUsers)
              .filter((user) => {
                return user.tableauIdentity === id.id
              })
              .orderBy(['normalizedEmail'])
              .value()
        };
      })
    }
  },
  mounted() {
    this.getTableauUsers();
    this.getTableauIdentities();
  },
  methods: {
    async getTableauUsers() {
      let resp = await this.axios.get('api/TableauUsers/Users');
      if (resp?.data) {
        this.tableauUsers = resp.data;
      }
    },
    tableauUsersByIdentity(id) {
      return _.filter(this.tableauUsers, (user) => {
        return user.tableauIdentity === id;
      });
    },
    async getTableauIdentities() {
      let resp = await this.axios.get('api/TableauUsers/TableauIdentities');
      if (resp?.data) {
        this.tableauIdentities = resp.data;
      }
    },
    async editPermission(user) {
      let resp = await this.axios.post('api/TableauUsers', {
        TableauAuthConfigId: user.tableauIdentity,
        UserEmail: user.normalizedEmail
      });
      if (resp.status === 200) {
        this.PromptSuccess(
            'Success',
            `Permission for user ${user.email} had been changed successfully.`
        );
      }
    }
  }
}
</script>

<style scoped>

</style>